export const Add = (value) => {
  var today = new Date();
  var date =
    today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate();
  var time =
    today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
  var dateTime = date + " " + time;
  return {
    type: "Add",
    data: {
      id: new Date().valueOf(),
      data: value,
      time: dateTime,
    },
  };
};

export const Dell = (value) => {
  return {
    type: "Dell",
    data: {
      id: new Date().valueOf(),
      data: value,
    },
  };
};
